import { render, staticRenderFns } from "./maitouList.vue?vue&type=template&id=5a1a9e31&scoped=true"
import script from "./maitouList.vue?vue&type=script&lang=js"
export * from "./maitouList.vue?vue&type=script&lang=js"
import style0 from "./maitouList.vue?vue&type=style&index=0&id=5a1a9e31&prod&lang=scss"
import style1 from "./maitouList.vue?vue&type=style&index=1&id=5a1a9e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a9e31",
  null
  
)

export default component.exports